const ANALYTICS_API_URLS = {
  mainnet: {
    base: "https://mainnet.analytics.tinyman.org/api",
    v1: "https://mainnet.analytics.tinyman.org/api/v1"
  },
  testnet: {
    base: "https://testnet.analytics.tinyman.org/api",
    v1: "https://testnet.analytics.tinyman.org/api/v1"
  }
};

export {ANALYTICS_API_URLS};
